import { render, staticRenderFns } from "./ChangeTmpPwdView.vue?vue&type=template&id=6334b92a&scoped=true&"
import script from "./ChangeTmpPwdView.vue?vue&type=script&lang=js&"
export * from "./ChangeTmpPwdView.vue?vue&type=script&lang=js&"
import style0 from "./ChangeTmpPwdView.vue?vue&type=style&index=0&id=6334b92a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6334b92a",
  null
  
)

export default component.exports